module.exports = __webpack_public_path__ + "img/swiper-button-next.6b0a41ce.svg";